import { defineStore } from 'pinia';
import { ref } from 'vue';
import {pageSettings} from "../../utils/src/pageSettings";

export const useMapStore = defineStore('map', () => {

    const settings = pageSettings('_dottie');
    const showMap = ref(!settings.hideResultsMap);

    const showSearchButton = ref(false);

    const disableMapMoveEvent = ref(false);

    function setShowMap(bool) {

        showMap.value = bool;

    }

    function toggleShowMap() {

        showMap.value = !showMap.value;

    }

    function setShowSearchButton(value) {

        showSearchButton.value = value;

    }

    function setDisableMapMoveEvent(value) {

        disableMapMoveEvent.value = value;

    }

    return {
        showMap,
        toggleShowMap,
        setShowMap,
        showSearchButton,
        setShowSearchButton,
        disableMapMoveEvent,
        setDisableMapMoveEvent,
    }

})
